import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { userListLoading: true, data: '', error: false };

export function userListReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_USER_LIST:
            return {
                userListLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_USER_LIST:
            return {
                userListLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_USER_LIST:
            return {
                userListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/userList.reducer.js